export default "__VITE_ASSET__DnP1h2K9__"